// extracted by mini-css-extract-plugin
export default {"FaqAskQuestion":"on_a bhi_qr bhi_a bhi_w","FaqAskQuestion__outdated":"on_b bhi_vp bhi_xe"};